import { useState, useContext } from "react"
import "./createUserPanel.css"
import AsyncSelect from "react-select/async"
import Select from 'react-select'
import {userRegister} from "../../services/authServices.js"
import {SearchContext} from "../../context/searchNameContext.js"

export default function CreateUserPanel({clousePanel}){

    const [name, setName] = useState("")
    const [password, setPassword] = useState("")
    const [email, setEmail] = useState("")
    const [numberPhone, setnumberPhone] = useState("")
    const [rol, setRol] = useState("")
    const [value, setValue] = useState([])

    const {loadOptionsNameTeam} = useContext(SearchContext)

    const rolOptions = [
        {value: "admin", label: "admin"},
        {value: "cliente", label: "cliente"}
    ]

    const handleSaveUser = async () => {
        const data = await userRegister(name, password, email, rol, numberPhone, value.value)
        console.log(data)
    }

    return(
        <form className="chat-panel">
            <div className="panel-header">
                <p className="ns-form-title">Crear usuario</p>
                <button className="btn-close" onClick={() => clousePanel()}>✕</button>
            </div>

            <div className="ns-field">
                <label className="ns-label">Nombre del usuario</label>
                <input
                    className="ns-input"
                    type="text" 
                    placeholder="Ej: Juan Pérez" 
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
            </div>

            <div className="ns-field">
                <label className="ns-label">Correo electronico</label>
                <input
                    className="ns-input"
                    placeholder="Ej: empresa@empresa.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
            </div>

            <div className="ns-field">
                <label className="ns-label">Numero telefonico</label>
                <input
                    className="ns-input"
                    placeholder="Escribe tu numero telefonico"
                    value={numberPhone}
                    onChange={(e) => setnumberPhone(e.target.value)}
                />
            </div>

            <div className="ns-field">
                <label className="ns-label">Contraseña</label>
                <input
                    type="password"
                    className="ns-input"
                    placeholder="Escribe tu constraseña"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </div>

            <div className="ns-field">
                <label className="ns-label">Clase</label>
                <Select
                        options={rolOptions} 
                        value={rolOptions.find(o => o.value === rol)}
                        onChange={(selected) => setRol(selected.value)}
                />
            </div>

            <div className="ns-field">
                <label className="ns-label">Añadir a grupo</label>
                <AsyncSelect
                    defaultOptions
                    loadOptions={loadOptionsNameTeam}
                    value={value}
                    onChange={setValue}
                    placeholder="Buscar a grupos..."
                />
            </div>

            <div className="panel-footer">
                <button className="ns-submit" onClick={handleSaveUser} disabled={ !name || !email || !password}>
                    Crear
                </button>
            </div>
        </form>
    )
}